module.exports = __webpack_public_path__ + "media/2.e30f248e.mp3";